import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

export const fetchUserActivity = createAsyncThunk(
  "userActivity/fetchUserActivity",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/superAdmin/user-activity", { params });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch activity");
    }
  }
);

export const fetchUserActivityStats = createAsyncThunk(
  "userActivity/fetchStats",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/superAdmin/user-activity/stats", { params });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch stats");
    }
  }
);

export const fetchDistinctUsers = createAsyncThunk(
  "userActivity/fetchDistinctUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/superAdmin/user-activity/users");
      return response.data.users;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch users");
    }
  }
);

export const fetchSessionPath = createAsyncThunk(
  "userActivity/fetchSessionPath",
  async (sessionId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/superAdmin/user-activity/session/${sessionId}`);
      return response.data.path;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

const userActivitySlice = createSlice({
  name: "userActivity",
  initialState: {
    activities: [],
    total: 0,
    page: 1,
    limit: 50,
    distinctUsers: [],
    stats: null,
    statsLoading: false,
    sessionPath: [],
    sessionPathLoading: false,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserActivity.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchUserActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.activities = action.payload.activities;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchUserActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDistinctUsers.fulfilled, (state, action) => {
        state.distinctUsers = action.payload;
      })
      .addCase(fetchUserActivityStats.pending, (state) => { state.statsLoading = true; })
      .addCase(fetchUserActivityStats.fulfilled, (state, action) => {
        state.statsLoading = false;
        state.stats = action.payload;
      })
      .addCase(fetchUserActivityStats.rejected, (state) => { state.statsLoading = false; })
      .addCase(fetchSessionPath.pending, (state) => { state.sessionPathLoading = true; state.sessionPath = []; })
      .addCase(fetchSessionPath.fulfilled, (state, action) => {
        state.sessionPathLoading = false;
        state.sessionPath = action.payload;
      })
      .addCase(fetchSessionPath.rejected, (state) => { state.sessionPathLoading = false; });
  },
});

export default userActivitySlice.reducer;
